module.exports = {
  attributes: {
    country: 'data-se-country-code',
    language: 'data-se-language-code',
  },
};
